export const mediaQuery = (query: string): boolean =>
  typeof window !== 'undefined' &&
  Object.hasOwnProperty.call(window, 'matchMedia')
    ? window.matchMedia(query).matches
    : false;
